import React from "react";
import "./About.css";
import { Bounce, Fade } from 'react-awesome-reveal';
import { FaCode, FaRocket, FaUsers, FaLightbulb } from 'react-icons/fa';
import photo from '../../assets/docs/Evolution-of-Coding-scaled.jpg';

const About = () => {
  return (
    <>
      <div className="about" id="about">
        <Bounce>
          <div className="about-header">
            <h1>About Me</h1>
            <div className="about-divider"></div>
            <p className="about-subtitle">Passionate Full Stack Developer</p>
          </div>
        </Bounce>
        
        <div className="about-content-wrapper">
          <Fade direction="left" duration={800}>
            <div className="about-image-section">
              <div className="image-container">
                <img src={photo} alt="Anish Singhal - Developer" />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <FaCode className="overlay-icon" />
                    <span>Full Stack Developer</span>
                  </div>
                </div>
              </div>
              <div className="image-content">
                <h3>Technical Expertise</h3>
                <div className="tech-stats">
                  <div className="stat-item">
                    <span className="stat-number">3+</span>
                    <span className="stat-label">Years Experience</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">20+</span>
                    <span className="stat-label">Projects Completed</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">10+</span>
                    <span className="stat-label">Technologies</span>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
          
          <Fade direction="right" duration={800} delay={200}>
            <div className="about-text-section">
              <div className="about-intro">
                <h2>Hello! I'm <span className="highlight">Anish Singhal</span></h2>
                <p className="intro-text">
                  A passionate and dedicated software developer with a strong foundation in web development, 
                  data structures, and algorithms. I love creating innovative and efficient software solutions 
                  that make a real impact.
                </p>
              </div>
              
              <div className="about-details">
                <p>
                  As a highly motivated developer, my primary career goal is to leverage my technical expertise 
                  to build high-quality, user-friendly applications. I continuously enhance my skills and stay 
                  updated with the latest industry trends and technologies.
                </p>
                
                <p>
                  With a keen interest in both frontend and backend development, I aspire to contribute to 
                  dynamic projects and work with diverse teams to solve complex problems. I seek to advance 
                  my career by taking on challenging roles that allow me to grow as a developer and make a 
                  meaningful impact in the tech industry.
                </p>
              </div>
              
              <div className="about-features">
                <div className="feature-item">
                  <FaRocket className="feature-icon" />
                  <div className="feature-content">
                    <h4>Innovation</h4>
                    <p>Creating cutting-edge solutions</p>
                  </div>
                </div>
                <div className="feature-item">
                  <FaUsers className="feature-icon" />
                  <div className="feature-content">
                    <h4>Collaboration</h4>
                    <p>Working with diverse teams</p>
                  </div>
                </div>
                <div className="feature-item">
                  <FaLightbulb className="feature-icon" />
                  <div className="feature-content">
                    <h4>Problem Solving</h4>
                    <p>Complex challenges made simple</p>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </>
  );
};

export default About;
